import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import parent from '@/api/parent';
import { mealDateIso } from '@/helper/cartFamily';

const { getParentDashboard } = parent();

/** Dashboard row for the active child + meal date (Menu paid slots, accordion). */
export default function useParentDashboardChild(mealDate) {
	const key = useSelector((state) => state.auth.key);
	const accountType = useSelector((state) => state.auth.accountType);
	const children = useSelector((state) => state.auth.children) || [];
	const childrenLoaded = useSelector((state) => state.auth.childrenLoaded);
	const selectedCustomerId = useSelector((state) => state.auth.selectedCustomerId);
	const accountId = useSelector((state) => state.auth.user?.id);

	const date = mealDateIso(mealDate);
	const childrenKey = children.map((c) => c.id).join(',');

	const enabled = Boolean(
		key &&
			childrenLoaded &&
			accountType === 'parent' &&
			children.length > 0 &&
			selectedCustomerId != null &&
			date
	);

	const { data, isFetching } = useQuery({
		queryKey: ['parent-dashboard-child', accountId, date, selectedCustomerId, childrenKey],
		enabled,
		placeholderData: keepPreviousData,
		queryFn: async () => {
			const res = await getParentDashboard({
				date,
				token: key,
				children,
			});
			return res.data;
		},
	});

	const childRow =
		data?.children?.find((c) => Number(c.id) === Number(selectedCustomerId)) || null;

	return { childRow, isFetching };
}
